import { makeAutoObservable } from "mobx";

export class SpoContentManagementStore {
  private readonly _isIndexing: Map<string, boolean> = new Map<string, boolean>();

  constructor() {
    makeAutoObservable(this);
  }

  public setKnowledgeBaseIsIndexing(knowledgeBaseId: string | undefined, isIndexing: boolean) {
    if (knowledgeBaseId?.length) {
      this._isIndexing.set(knowledgeBaseId, isIndexing);
    }
  }

  public isKnowledgeBaseIndexing(knowledgeBaseId: string | undefined): boolean {
    return (!!knowledgeBaseId?.length && this._isIndexing.get(knowledgeBaseId)) ?? false;
  }

  public isAnyKnowledgeBaseIndexing(): boolean {
    return Array.from(this._isIndexing.values()).some(isIndexing => isIndexing);
  }
}
